<template>
    <div>
      <el-form label-position="top" label-width="100px">
						<div class="row">
							<div class="col-md-5">	
								<el-form-item label="Station">
									<el-select v-model="stationid" clearable filterable placeholder="Select Station" size="small" style="width:100%;">
										<el-option v-for="item7 in stationlist" :key="item7.StationId" :label="item7.StationName" :value="item7.StationId">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="col-md-2">	
								<el-form-item label=" ">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Submit</el-button>
								</el-form-item>
							</div>
						</div>
						<div class="row"></div>
					</el-form>

      <div class="table-container">
        <div class="table-content" ref="tableContent" style="height: 100px;">
          <b-table
            striped
            hover
            :items="pagedItems"
            :fields="fields"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            :lock-scroll="true"
            class="custom-table"
            :thead-row-class="'custom-table-header-row'"
          >
            <template #cell(index)="data">
              {{ (currentPage - 1) * perPage + data.index + 1 }}
            </template>
            <template #cell(DepositCount)="data">
              {{ formatNumber(data.item.DepositCount) }}
            </template>
            <template #cell(TotalTransactionValue)="data">
              {{ formatDecimal(data.item.TotalTransactionValue) }}
            </template>
            <template #cell(actions)="data">
              <el-button size="small" type="primary" @click="detailItem(data.item)">
                Detail
              </el-button>
            </template>
          </b-table>
        </div>
    
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div class="d-flex align-items-center">
            <label class="mr-2">{{ `Showing ${((currentPage - 1) * perPage) + 1} to ${Math.min(currentPage * perPage, totalRows)} of ${totalRows} rows` }}</label>
            <b-form-group label-class="sr-only" class="mb-0">
              <b-form-select
                v-model="perPage"
                :options="perPages"
                ref="perPageSelect"
                @shown="adjustDropdownHeight"
              ></b-form-select>
            </b-form-group>
          </div>
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @input="pageChanged"
            ></b-pagination>
          </div>
        </div>

        <Loader v-if="loading.table" />


        <TodaySummaryByDateDialogDetail :dialogByDateDetailVisible.sync="dialogByDateDetailVisible" :depositDateDetail="depositDateDetail" :itemDetail="itemDetail"/>
      </div>
    </div>
  </template>
  
  <script>
  import { Rainbow, Rainbow3, Config, AxiosWithJar, Penanggalan } from '@/utility.js'
  import TodaySummaryByDateDialogDetail from '@/views/pages/Finance/CashDeposit/Report/TodaySummaryByDateDialogDetail.vue'
  import Loader from '@/components/loader/Loader2.vue'

  export default {
    components: { 
      Loader,
      TodaySummaryByDateDialogDetail,
    },
    props: {
      depositDate: {
        type: String,
        default: '',
        required: false,
      },
      stationlist : {
        type: Array,
        default: () => ({}),
        required: false,
      },
    },
    data() {
      return {
        dialogByDateDetailVisible: false,
        depositDateDetail: '',
        itemDetail: null,
        stationid : '',

        items: [],
        fields: [
          { key: 'index', label: '#', sortable: false },
          { key: 'DepositDate', label: 'Date', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
          { key: 'MachineSn', label: 'Machine SN', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
          { key: 'StationId', label: 'Station Id', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
          { key: 'StationName', label: 'Station Name', sortable: true, thClass: 'text-left', tdClass: 'text-left' },
          { key: 'TotalTransactionValue', label: 'Total Transaction Value', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
          { key: 'DepositCount', label: 'Deposit Count', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
          { key: 'actions', label: '', sortable: false , thClass: 'text-center', tdClass: 'text-center' }
        ],
        currentPage: 1,
        perPage: 10,
        filter: '',
        totalRows: 0,
        sortBy: '',
        sortDesc: false,
        perPages: [10, 15, 20],
        selectedDate: '',

        loading : {
          table:false,
          isSuccess : false,
        }
      };
    },
    computed: {
      pagedItems() {
        const startIndex = (this.currentPage - 1) * this.perPage;
        const endIndex = startIndex + this.perPage;
        return this.items.slice(startIndex, endIndex);
      }
    },
    mounted() {
      this.getData();
      this.updateTableHeight();
      window.addEventListener('resize', this.updateTableHeight);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateTableHeight);
    },
    methods: {
      async loadData() {
        //for Example
        for (let i = 0; i < 12; i++) {
          this.items.push({
            name: `Person ${i + 1}`,
            age: Math.floor(Math.random() * 50) + 20,
            decimal: Math.random() * 10000
          });
        }
        this.totalRows = this.items.length;
      },

      getData() {
        this.urlRequestParams=Config().apiURL
        this.urlRequestParams+='/v1/cashdeposit/todaysummarybydate?'
        //this.urlRequestParams+='&date-range-start='+this.date.Start
        //this.urlRequestParams+='&date-range-end='+this.date.End

        //console.log('daterange: ' + this.dateRange)
        //console.log('this.dateRange[0]: ' + this.dateRange[0])
        //console.log('this.dateRange[1]: ' + this.dateRange[1])
        //this.urlRequestParams+='&date-range-start='+ (this.dateRange ? this.dateRange[0] : 'undefined')
        //this.urlRequestParams+='&date-range-end='+ (this.dateRange ? this.dateRange[1] : 'undefined')

        //if(this.monthRange[0] != 'undefined')
        //this.urlRequestParams+='&month-range-start='+ this.monthRange[0]

        //if(this.monthRange[1] != 'undefined')
        //this.urlRequestParams+='&month-range-end='+ this.monthRange[1]

        //this.urlRequestParams+='&period='+this.period
        //this.urlRequestParams+='&plant='+this.plantno
        this.urlRequestParams+='&stationid='+this.stationid
        this.urlRequestParams+='&date='+this.depositDate

        this.loading.table = true;
        this.loading.isSuccess = false;
        AxiosWithJar().get(this.urlRequestParams)
          .then((response)=>{ 
            this.loading.isSuccess = true;
            this.reportdata = response.data;

            this.items = response.data.data;

            this.totalRows = this.items.length;

            this.loading.table = false;
          })
          .catch(error => {
            console.log(error)
            //this.errored = true
            //error.response.data
          })
          .finally(() => {
            this.loading.table = false;
          })
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
      },
      formatNumber(value) {
        return new Intl.NumberFormat('en-US', { style: 'decimal', currency: 'USD' }).format(value);
      },
      formatDecimal(value) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
      },
      detailItem(item) {
        const index = this.items.indexOf(item);
        console.log('detail item: ' + JSON.stringify(item));

        this.dialogByDateDetailVisible = true;
        this.depositDateDetail = item.DepositDate;
        this.itemDetail = item; 
        /*
        if (index !== -1) {
          this.items.splice(index, 1);
          this.totalRows--;
        } */
      },
      adjustDropdownHeight() {
        const paginationHeight = this.$refs.perPageSelect.$el.offsetHeight;
        this.$refs.perPageSelect.$el.style.height = `${paginationHeight}px`;
      },
      pageChanged(newPage) {
        this.currentPage = newPage;
      },
      sortData() {
        if (this.sortBy) {
            this.items.sort((a, b) => {
            const modifier = this.sortDesc ? -1 : 1;
            const valueA = typeof a[this.sortBy] === 'string' ? parseFloat(a[this.sortBy].replace(/[^0-9.-]+/g, '')) : a[this.sortBy];
            const valueB = typeof b[this.sortBy] === 'string' ? parseFloat(b[this.sortBy].replace(/[^0-9.-]+/g, '')) : b[this.sortBy];
            if (valueA < valueB) return -1 * modifier;
            if (valueA > valueB) return 1 * modifier;
            return 0;
            });
        }
     },
     updateTableHeight() {
      const container = this.$refs.tableContent;
      const windowHeight = window.innerHeight - 160;
      const paginationHeight = 0; //this.$refs.paginationContainer.offsetHeight;
      //container.style.height = `${windowHeight}px`;
      //container.style.height = `${windowHeight - paginationHeight - 20}px`; // 20px for some padding
      //console.log('windowHeight: ' + windowHeight);
      //console.log('paginationHeight: ' + paginationHeight);
    },
    applyFilter() {
      this.getData();
      console.log('filter by station');
    },
       
    },
    watch: {
      depositDate(newVal, oldVal) {
        console.log(`DepositDate changed from ${oldVal} to ${newVal}`);
        this.getData();
      },
      sortBy() {
        this.sortData();
      },
      sortDesc() {
        this.sortData();
      }
    },

  };
  </script>
  
  <style>
  .custom-table thead th {
  height: 55px; /* Atur tinggi header tabel sesuai kebutuhan Anda */
  vertical-align: middle;
}


/*
.table-container {
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  height: 100vh;
}
*/

.table-container {
  display: flex;
  flex-direction: column;
  /*height: 100vh;*/
}

.table-content {
  overflow-y: auto;
  flex: 1;
}

.pagination-container {
  flex-shrink: 0;
}

  </style>